import { paginationStyle } from '@bingads-webui-campaign-react/common-styles';
import { merge } from '@bingads-webui-universal/primitive-utilities';

export const getOverridePaginationStyles = (_, { palette = {} }) => ({
  '.pagination-container': {
    display: 'flex',
    justifyContent: 'flex-end',
    ...merge({
      '& .ba-pagination': {
        height: 24,
        '& .btn.prev, .btn.next': {
          height: 24,
          verticalAlign: 'unset',
        },
        '& > .text': {
          display: 'inline-block',
          padding: '0px 0px 4px 5px',
          verticalAlign: 'middle',
        },

        '& input.pager-input': {
          height: 24,
          width: 32,
          margin: 0,
        },
      },
    }, paginationStyle({ palette })),
  },
});
